export class CustomerInsuranceInfo {
    adotCode: string = null;
    naicCode: string = null;
    companyName: string = null;
    customerId: number = null;
    insurancePolicyHolderId: number = null;
    insurancePolicyVehicleId: number = null;
    policyId: number = null;
    policyNumber: string = null;
    policyTypeId: number = null;
    policyType: string = null;
    policyHolder: string = null;
    policySourceTypeId: number = null;
    policySourceType: string = null;
    vehicleId: number = null;
    notifyDate: Date = null;
    effectiveDate: Date = null;
    endDate: Date = null;
    createdDate: Date;
    insurancePolicyHolderCreatedDate: Date;
    insurancePolicyVehicleCreatedDate: Date;
}
